import { SelectedQuestionDetailsState } from '../../store/addStimulusToQuestion/types';
import { SectionProperties } from './services/SectionLayoutService';
import { ResourceAttribute } from './types';

export enum TypeKeys {
    CONTEXT_ITEMS_LOADED = 'structureEditor/CONTEXT_ITEMS_LOADED',
    FETCH_STRUCTURE_EDITOR_LIVE_DATA = 'FETCH_STRUCTURE_EDITOR_LIVE_DATA',
    ITEM_MOVE_AT_POSITION = 'structureEditor/ITEM_MOVE_AT_POSITION',
    SET_MOVING_OBJECT_ID = 'structureEditor/SET_MOVING_OBJECT_ID',
    ITEM_DUPLICATE = 'structureEditor/ITEM_DUPLICATE',
    ITEM_RENAME = 'structureEditor/ITEM_RENAME',
    CONTENT_RENAME = 'structureEditor/CONTENT_RENAME',
    INLINE_SECTION_RENAME = 'structureEditor/INLINE_SECTION_RENAME',
    ITEM_REMOVE = 'structureEditor/ITEM_REMOVE',
    ITEM_SAVE_AS_TEMPLATE = 'structureEditor/ITEM_SAVE_AS_TEMPLATE',
    ITEM_SET_WEIGHT = 'structureEditor/ITEM_SET_WEIGHT',
    SET_STRUCTURE_EDITOR_LOCK = 'structureEditor/SET_STRUCTURE_EDITOR_LOCK',
    SET_APPLY_EDIT_PROPERTIES_IN_PROGRESS = 'structureEditor/SET_APPLY_EDIT_PROPERTIES_IN_PROGRESS',
    SHOW_ITEM_MENU_MODAL = 'structureEditor/SHOW_REMOVE_ITEM_MODAL',
    CLOSE_ITEM_MENU_MODAL = 'structureEditor/CLOSE_ITEM_MENU_MODAL',
    CONFIRM_ITEM_MENU_MODAL_ACTION = 'structureEditor/CONFIRM_ITEM_MENU_MODAL_ACTION',
    CONFIRM_SET_WEIGHT_MODAL_ACTION = 'structureEditor/CONFIRM_SET_WEIGHT_MODAL_ACTION',
    SET_EDITED_ITEM_PROPERTIES = 'structureEditor/SET_EDITED_ITEM_PROPERTIES',
    EDIT_SECTION_LAYOUT = 'structureEditor/EDIT_SECTION_LAYOUT',
    ITEMS_INDEX_UPDATED = 'structureEditor/ITEMS_INDEX_UPDATED',
    RESET_ITEM_PROPERTIES = 'structureEditor/RESET_ITEM_PROPERTIES',
    REMOVE_STIMULUS_FROM_LAYOUT = 'structureEditor/REMOVE_STIMULUS_FROM_LAYOUT',
    TOGGLE_EXPAND_SECTION_IDS = 'structureEditor/TOGGLE_EXPAND_SECTION_IDS',
    ADD_INLINE_SECTION = 'structureEditor/ADD_INLINE_SECTION',
    UPLOAD_RESOURCE = 'structureEditor/UPLOAD_RESOURCE',
    SAVE_FILE_RESOURCE = 'structureEditor/SAVE_FILE_RESOURCE',
    FETCH_AUDIO_SCRIPT_DATA = 'structureEditor/FETCH_AUDIO_SCRIPT_DATA',
    SET_AUDIO_SCRIPT_DATA = 'structureEditor/SET_AUDIO_SCRIPT_DATA',
    SET_UPLOAD_RESPONSE = 'structureEditor/SET_UPLOAD_RESPONSE',
    SET_ACTIVE_TAB = 'structureEditor/SET_ACTIVE_TAB',
    RESOURCE_RENAME = 'structureEditor/RESOURCE_RENAME',
    RESOURCE_URL_RENAME = 'structureEditor/RESOURCE_URL_RENAME',
    FETCH_PCI_RESOURCE_TEMPLATES = 'structureEditor/FETCH_PCI_RESOURCE_TEMPLATES',
    FETCH_PCI_RESOURCE_TEMPLATES_SUCCESS = 'structureEditor/FETCH_PCI_RESOURCE_TEMPLATES_SUCCESS',
    FETCH_PCI_RESOURCE_TEMPLATES_ERROR = 'structureEditor/FETCH_PCI_RESOURCE_TEMPLATES_ERROR',
    CREATE_PCI_RESOURCE_REFERENCE = 'structureEditor/CREATE_PCI_RESOURCE_REFERENCE',
    FETCH_PCI_STIMULUS_TEMPLATES = 'structureEditor/FETCH_PCI_STIMULUS_TEMPLATES',
    FETCH_PCI_STIMULUS_TEMPLATES_SUCCESS = 'structureEditor/FETCH_PCI_STIMULUS_TEMPLATES_SUCCESS',
    FETCH_PCI_STIMULUS_TEMPLATES_ERROR = 'structureEditor/FETCH_PCI_STIMULUS_TEMPLATES_ERROR',
}

export enum ItemMenuActionIdKeys {
    NOT_SET = 'NOT_SET',
    ITEM_MOVE_TOP = 'ITEM_MOVE_TOP',
    ITEM_MOVE_UP = 'ITEM_MOVE_UP',
    ITEM_MOVE_DOWN = 'ITEM_MOVE_DOWN',
    ITEM_MOVE_BOTTOM = 'ITEM_MOVE_BOTTOM',
    DUPLICATE_ITEM = 'DUPLICATE_ITEM',
    RENAME_ITEM = 'RENAME_ITEM',
    SAVE_ITEM_AS_TEMPLATE = 'SAVE_ITEM_AS_TEMPLATE',
    REMOVE_ITEM = 'REMOVE_ITEM',
    DELETE_ITEM = 'DELETE_ITEM',
    SET_WEIGHT_ITEM = 'SET_WEIGHT_ITEM',
    QUESTION_VIEW = 'QUESTION_VIEW',
    ASSERT_VIEW = 'ASSERT_VIEW',
}

export type ItemMenuActionId = ItemMenuActionIdKeys.ITEM_MOVE_TOP|ItemMenuActionIdKeys.ITEM_MOVE_UP|ItemMenuActionIdKeys.ITEM_MOVE_DOWN
    |ItemMenuActionIdKeys.ITEM_MOVE_BOTTOM|ItemMenuActionIdKeys.DUPLICATE_ITEM|ItemMenuActionIdKeys.RENAME_ITEM|ItemMenuActionIdKeys.REMOVE_ITEM
    |ItemMenuActionIdKeys.SAVE_ITEM_AS_TEMPLATE|ItemMenuActionIdKeys.SET_WEIGHT_ITEM|ItemMenuActionIdKeys.NOT_SET;

export type AddInlineSection = {
    type: TypeKeys.ADD_INLINE_SECTION;
    featureId: string;
    title: string;
    contextContentItemId: number;
}

export type ContextItemsLoaded = {
    type: TypeKeys.CONTEXT_ITEMS_LOADED;
    featureId: string;
    items: any;
}

export type SetEditedItemProperties = {
    type: TypeKeys.SET_EDITED_ITEM_PROPERTIES;
    featureId: string;
    editedItemProperties: SectionProperties;
}

export type ApplyEditedItemProperties = {
    type: TypeKeys.EDIT_SECTION_LAYOUT;
    featureId: string;
    editedItemProperties: SectionProperties;
    isStimulusTypeEdited: boolean;
    shouldDeleteStimulus: boolean;
    stimulusId: number;
    parentId: number;
    selectedQuestionDetails? : SelectedQuestionDetailsState;
}

export type ResetEditedItemProperties = {
    type: TypeKeys.RESET_ITEM_PROPERTIES;
    sectionId: number;
    featureId: string;
}

export type RemoveStimulusFromLayout = {
    type: TypeKeys.REMOVE_STIMULUS_FROM_LAYOUT;
    featureId: string;
    contextContentItemId: number;
    contentItemIds: number;
    parentId: number;
    closeOverlay?: boolean;
}

export type ItemsIndexUpdatePushed = {
    type: TypeKeys.ITEMS_INDEX_UPDATED;
    featureId: string;
}

export type ItemMovedAtPosition = {
    type: TypeKeys.ITEM_MOVE_AT_POSITION;
    featureId: string;
    nextPosition: any;
    prevPosition?: any;
    dragItem?: any;
}

export type SetMovingObjectId = {
    type: TypeKeys.SET_MOVING_OBJECT_ID;
    payload: number;
}

export type FetchStructureEditorLiveData = {
    type: TypeKeys.FETCH_STRUCTURE_EDITOR_LIVE_DATA;
    featureId: string;
}

export type DuplicateItem = {
    type: TypeKeys.ITEM_DUPLICATE;
    featureId: string;
    item: any;
}

export type RenameItem = {
    type: TypeKeys.ITEM_RENAME;
    featureId: string;
    item: any;
}

export type RenameContentInContext = {
    type: TypeKeys.CONTENT_RENAME;
    featureId: string;
    title: any;
    contentItemId: number;
    contextContentItemId?: number;
}

export type RenameInlineSection = {
    type: TypeKeys.INLINE_SECTION_RENAME;
    featureId: string;
    title: any;
    sectionId: number;
    contextContentItemId?: number;
}

export type RenameResourceInContext = {
    type: TypeKeys.RESOURCE_RENAME;
    featureId: string;
    title: any;
    objectId: number;
    contextContentItemId?: number;
}

export type RenameURLResourceInContext = {
    type: TypeKeys.RESOURCE_URL_RENAME;
    featureId: string;
    title: string;
    item: any;
}

export type RemoveItem = {
    type: TypeKeys.ITEM_REMOVE;
    featureId: string;
    item: any;
}

export type SaveItemAsTemplate = {
    type: TypeKeys.ITEM_SAVE_AS_TEMPLATE;
    featureId: string;
    item: any;
}

export type SetItemItemWeight = {
    type: TypeKeys.ITEM_SET_WEIGHT;
    featureId: string;
    item: any;
}

export type SetStructureEditorLock = {
    featureId: string;
    isStructureEditorLocked: boolean;
    type: TypeKeys.SET_STRUCTURE_EDITOR_LOCK;
}

export type SetExpandedSectionIds = {
    featureId: string;
    sectionIds: number[];
    type: TypeKeys.TOGGLE_EXPAND_SECTION_IDS;
}

export type SetApplyEditPropertiesInProgress = {
    featureId: string;
    isApplyEditPropertiesInProgress: boolean;
    type: TypeKeys.SET_APPLY_EDIT_PROPERTIES_IN_PROGRESS;
}

export type ShowItemActionConfirmationModal = {
    type: TypeKeys.SHOW_ITEM_MENU_MODAL;
    item: any;
    selectedMenuActionId: ItemMenuActionId;
    featureId: string;
}

export type CloseItemMenuModal = {
    type: TypeKeys.CLOSE_ITEM_MENU_MODAL;
    featureId: string;
}

export type ConfirmItemMenuModalAction = {
    type: TypeKeys.CONFIRM_ITEM_MENU_MODAL_ACTION;
    featureId: string;
    item: any;
    confirmedMenuActionId: ItemMenuActionId;
    newTitle: string;
    newPublishStatus: string;
}

export type ConfirmSetWeightModalAction = {
    type: TypeKeys.CONFIRM_SET_WEIGHT_MODAL_ACTION;
    featureId: string;
    item: any;
    weight: number;
}

export type UploadResource = {
    type: TypeKeys.UPLOAD_RESOURCE;
    file: File;
    featureId: string;
}

export type SaveFileResource = {
    type: TypeKeys.SAVE_FILE_RESOURCE;
    ticket: string;
    title: string;
    soundCategoryData?: ResourceAttribute[];
    featureId: string;
}

export type FetchAudioScriptData = {
    contentItemId: number;
    type: TypeKeys.FETCH_AUDIO_SCRIPT_DATA;
}

export type SetAudioScriptData = {
    payload: any;
    type: TypeKeys.SET_AUDIO_SCRIPT_DATA;
}

export type SetUploadResponse = {
    payload: any;
    type: TypeKeys.SET_UPLOAD_RESPONSE;
}

export type SetStructureEditorActiveTab = {
    activeTab: any;
    type: TypeKeys.SET_ACTIVE_TAB;
}

export type PciResourceTemplate = {
    templateContentItemId: number;
    templateContentRevisionId?: number;
    title: string;
    iconSrc?: string | null;
    key: string;
};

export type FetchPciResourceTemplates = {
    type: TypeKeys.FETCH_PCI_RESOURCE_TEMPLATES;
    featureId: string;
    itemBankId?: number;
};

export type FetchPciResourceTemplatesSuccess = {
    type: TypeKeys.FETCH_PCI_RESOURCE_TEMPLATES_SUCCESS;
    featureId: string;
    templates: PciResourceTemplate[];
};

export type FetchPciResourceTemplatesError = {
    type: TypeKeys.FETCH_PCI_RESOURCE_TEMPLATES_ERROR;
    featureId: string;
    error: any;
};

export type CreatePciResourceReference = {
    type: TypeKeys.CREATE_PCI_RESOURCE_REFERENCE;
    featureId: string;
    resourceContentItemId: number;
    resourceContentRevisionId?: number;
    title: string;
};

export const closeItemMenuModal = (featureId: string): CloseItemMenuModal => ({
    featureId,
    type: TypeKeys.CLOSE_ITEM_MENU_MODAL,
});

export const showItemMenuModal = (featureId: string, item: any, selectedMenuActionId: ItemMenuActionId): ShowItemActionConfirmationModal => ({
    featureId,
    item,
    selectedMenuActionId,
    type: TypeKeys.SHOW_ITEM_MENU_MODAL,
});

export const confirmItemMenuModalAction = (
    featureId: string, item: any, confirmedMenuActionId: ItemMenuActionId, newTitle?: string, newPublishStatus?: string,
): ConfirmItemMenuModalAction => ({
    featureId,
    item,
    newTitle,
    newPublishStatus,
    confirmedMenuActionId,
    type: TypeKeys.CONFIRM_ITEM_MENU_MODAL_ACTION,
});

export const confirmSetWeightModalAction = (
    featureId: string, item: any, weight: number,
): ConfirmSetWeightModalAction => ({
    featureId,
    item,
    weight,
    type: TypeKeys.CONFIRM_SET_WEIGHT_MODAL_ACTION,
});

export const fetchStructureEditorLiveData = (featureId: string): FetchStructureEditorLiveData => ({
    featureId,
    type: TypeKeys.FETCH_STRUCTURE_EDITOR_LIVE_DATA,
});

export const contextItemsLoaded = (featureId: string, items: any): ContextItemsLoaded => ({
    featureId,
    items,
    type: TypeKeys.CONTEXT_ITEMS_LOADED,
});

export const addInlineSection = (featureId: string, title: string, contextContentItemId: number): AddInlineSection => ({
    featureId,
    title,
    contextContentItemId,
    type: TypeKeys.ADD_INLINE_SECTION,
});

export const setEditedItemProperties = (featureId: string, editedItemProperties: SectionProperties): SetEditedItemProperties => ({
    featureId,
    editedItemProperties,
    type: TypeKeys.SET_EDITED_ITEM_PROPERTIES,
});

export const applyEditedItemProperties = (
    featureId: string,
    editedItemProperties: SectionProperties,
    isStimulusTypeEdited: boolean,
    shouldDeleteStimulus: boolean,
    stimulusId: number,
    parentId: number,
    selectedQuestionDetails?: SelectedQuestionDetailsState
): ApplyEditedItemProperties => ({
    type: TypeKeys.EDIT_SECTION_LAYOUT,
    featureId,
    editedItemProperties,
    isStimulusTypeEdited,
    shouldDeleteStimulus,
    stimulusId,
    parentId,
    selectedQuestionDetails,
});

export const resetEditedItemProperties = (featureId: string, sectionId?: number): ResetEditedItemProperties => ({
    featureId,
    sectionId,
    type: TypeKeys.RESET_ITEM_PROPERTIES,
});

export const removeStimulusFromLayout = (
    featureId: string, contextContentItemId: number, contentItemIds: number, parentId?: number, closeOverlay?: boolean
): RemoveStimulusFromLayout => ({
    featureId,
    contextContentItemId,
    contentItemIds,
    parentId,
    closeOverlay,
    type: TypeKeys.REMOVE_STIMULUS_FROM_LAYOUT,
});

export const setStructureEditorLock = (featureId: string, isStructureEditorLocked: boolean): SetStructureEditorLock => ({
    featureId,
    isStructureEditorLocked,
    type: TypeKeys.SET_STRUCTURE_EDITOR_LOCK,
});

export const toggleExpandSectionIds = (featureId: string, sectionIds: number[]): SetExpandedSectionIds => ({
    featureId,
    sectionIds,
    type: TypeKeys.TOGGLE_EXPAND_SECTION_IDS,
});

export const setApplyEditPropertiesInProgress = (featureId: string, isApplyEditPropertiesInProgress: boolean): SetApplyEditPropertiesInProgress => ({
    featureId,
    isApplyEditPropertiesInProgress,
    type: TypeKeys.SET_APPLY_EDIT_PROPERTIES_IN_PROGRESS,
});

export const itemsIndexUpdatePushed = (featureId: string): ItemsIndexUpdatePushed => ({
    featureId,
    type: TypeKeys.ITEMS_INDEX_UPDATED,
});

export const itemMoveAtPosition = (featureId: string, nextPosition: any, prevPosition?: any, dragItem?: any): ItemMovedAtPosition => ({
    featureId,
    nextPosition,
    prevPosition,
    dragItem,
    type: TypeKeys.ITEM_MOVE_AT_POSITION,
});

export const setMovingObjectId = (movingObjectId: number): SetMovingObjectId => ({
    type: TypeKeys.SET_MOVING_OBJECT_ID,
    payload: movingObjectId,
});

export const duplicateItem = (featureId: string, item: any): DuplicateItem => ({
    featureId,
    item,
    type: TypeKeys.ITEM_DUPLICATE,
});

export const renameItem = (featureId: string, item: any): RenameItem => ({
    featureId,
    item,
    type: TypeKeys.ITEM_RENAME,
});

export const renameResourceItem = (featureId: string, title: any, objectId: number, contextContentItemId?: number): RenameResourceInContext => ({
    featureId,
    title,
    objectId,
    contextContentItemId,
    type: TypeKeys.RESOURCE_RENAME,
});

export const renameURLResourceItem = (featureId: string, title: string, item:any ): RenameURLResourceInContext => ({
    featureId,
    title,
    item,
    type: TypeKeys.RESOURCE_URL_RENAME,
});

export const renameInlineSection = (featureId: string, title: any, sectionId: number, contextContentItemId?: number): RenameInlineSection => ({
    featureId,
    title,
    sectionId,
    contextContentItemId,
    type: TypeKeys.INLINE_SECTION_RENAME,
});

export const renameContentInContext = (featureId: string, title: any, contentItemId: number,
    contextContentItemId?: number): RenameContentInContext => ({
    featureId,
    title,
    contentItemId,
    contextContentItemId,
    type: TypeKeys.CONTENT_RENAME,
});

export const removeItem = (featureId: string, item: any): RemoveItem => ({
    featureId,
    item,
    type: TypeKeys.ITEM_REMOVE,
});

export const saveItemAsTemplate = (featureId: string, item: any): SaveItemAsTemplate => ({
    featureId,
    item,
    type: TypeKeys.ITEM_SAVE_AS_TEMPLATE,
});

export const setWeightItem = (featureId: string, item: any): SetItemItemWeight => ({
    featureId,
    item,
    type: TypeKeys.ITEM_SET_WEIGHT,
});

export const uploadResource = (featureId: string, file: File): UploadResource => ({
    featureId,
    file,
    type: TypeKeys.UPLOAD_RESOURCE,
});

export const saveFileResource = (featureId: string, ticket: string, title: string, soundCategoryData: ResourceAttribute[]): SaveFileResource => ({
    featureId,
    ticket,
    title,
    soundCategoryData,
    type: TypeKeys.SAVE_FILE_RESOURCE,
});

export const fetchAudioScriptData = (contentItemId: number): FetchAudioScriptData => ({
    contentItemId,
    type: TypeKeys.FETCH_AUDIO_SCRIPT_DATA,
});

export const setAudioScriptdata = (payload: any): SetAudioScriptData => ({
    payload,
    type: TypeKeys.SET_AUDIO_SCRIPT_DATA,
});

export const setUploadResponse = (payload: any): any => ({
    payload,
    type: TypeKeys.SET_UPLOAD_RESPONSE,
});

export const setStructureEditorActiveTab = (activeTab: any): SetStructureEditorActiveTab => ({
    activeTab,
    type: TypeKeys.SET_ACTIVE_TAB,
});

export const fetchPciResourceTemplates = (
    featureId: string,
    itemBankId?: number
): FetchPciResourceTemplates => ({
    featureId,
    itemBankId,
    type: TypeKeys.FETCH_PCI_RESOURCE_TEMPLATES,
});

export const fetchPciResourceTemplatesSuccess = (
    featureId: string,
    templates: PciResourceTemplate[]
): FetchPciResourceTemplatesSuccess => ({
    featureId,
    templates,
    type: TypeKeys.FETCH_PCI_RESOURCE_TEMPLATES_SUCCESS,
});

export const fetchPciResourceTemplatesError = (
    featureId: string,
    error: any
): FetchPciResourceTemplatesError => ({
    featureId,
    error,
    type: TypeKeys.FETCH_PCI_RESOURCE_TEMPLATES_ERROR,
});

export const createPciResourceReference = (
    featureId: string,
    resourceContentItemId: number,
    title: string,
    resourceContentRevisionId?: number
): CreatePciResourceReference => ({
    featureId,
    resourceContentItemId,
    resourceContentRevisionId,
    title,
    type: TypeKeys.CREATE_PCI_RESOURCE_REFERENCE,
});

export type FetchPciStimulusTemplates = {
    type: TypeKeys.FETCH_PCI_STIMULUS_TEMPLATES;
    featureId: string;
    itemBankId?: number;
};

export type FetchPciStimulusTemplatesSuccess = {
    type: TypeKeys.FETCH_PCI_STIMULUS_TEMPLATES_SUCCESS;
    featureId: string;
    templates: PciResourceTemplate[];
};

export type FetchPciStimulusTemplatesError = {
    type: TypeKeys.FETCH_PCI_STIMULUS_TEMPLATES_ERROR;
    featureId: string;
    error: any;
};

export const fetchPciStimulusTemplates = (
    featureId: string,
    itemBankId?: number
): FetchPciStimulusTemplates => ({
    featureId,
    itemBankId,
    type: TypeKeys.FETCH_PCI_STIMULUS_TEMPLATES,
});

export const fetchPciStimulusTemplatesSuccess = (
    featureId: string,
    templates: PciResourceTemplate[]
): FetchPciStimulusTemplatesSuccess => ({
    featureId,
    templates,
    type: TypeKeys.FETCH_PCI_STIMULUS_TEMPLATES_SUCCESS,
});

export const fetchPciStimulusTemplatesError = (
    featureId: string,
    error: any
): FetchPciStimulusTemplatesError => ({
    featureId,
    error,
    type: TypeKeys.FETCH_PCI_STIMULUS_TEMPLATES_ERROR,
});

export type ActionTypes =
    ContextItemsLoaded |
    SetEditedItemProperties |
    ApplyEditedItemProperties |
    ResetEditedItemProperties |
    ItemsIndexUpdatePushed |
    SetStructureEditorLock |
    FetchStructureEditorLiveData |
    ItemMovedAtPosition |
    DuplicateItem |
    SetMovingObjectId |
    RenameItem |
    RemoveItem |
    SaveItemAsTemplate |
    SetItemItemWeight |
    ShowItemActionConfirmationModal |
    CloseItemMenuModal |
    ConfirmItemMenuModalAction |
    ConfirmSetWeightModalAction |
    SetExpandedSectionIds |
    SetApplyEditPropertiesInProgress |
    UploadResource |
    SaveFileResource |
    FetchAudioScriptData |
    SetAudioScriptData |
    SetUploadResponse |
    SetStructureEditorActiveTab |
    FetchPciResourceTemplates |
    FetchPciResourceTemplatesSuccess |
    FetchPciResourceTemplatesError |
    CreatePciResourceReference |
    FetchPciStimulusTemplates |
    FetchPciStimulusTemplatesSuccess |
    FetchPciStimulusTemplatesError;

export const getValidMenuActionItem = (itemMenuActionId: ItemMenuActionId) => {
    return [ItemMenuActionIdKeys.SET_WEIGHT_ITEM, ItemMenuActionIdKeys.REMOVE_ITEM].includes(itemMenuActionId);
};
